export default [
    {
        name: 'downloadPdf',
        url: '/downloadPdf'
    }
];
